import React from 'react';

import PropTypes from 'prop-types';

import MatchWhenAuthorized from 'pages/MatchWhenAuthorised';

import FormsPage from '../Forms/Forms'

const MandatoryFeedbackRoutes = (props) => {
  const { url } = props;
  return (
    // <Routes>
      <MatchWhenAuthorized
        exact
        path={url}
        component={FormsPage}
      />
    // </Routes>
  );
};

MandatoryFeedbackRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default MandatoryFeedbackRoutes;
